import { cn } from '@/shared/utils'
import { Utensils, Shirt } from 'lucide-react'
import type { vendorType } from '@/shared/types'

interface VendorBadgeProps {
  type: vendorType
  size?: 'sm' | 'md' | 'lg'
}

export function VendorBadge({ type, size = 'md' }: VendorBadgeProps) {
  const sizeStyles = {
    sm: 'px-2 py-0.5 text-xs gap-1',
    md: 'px-3 py-1 text-sm gap-1.5',
    lg: 'px-4 py-1.5 text-base gap-2',
  }

  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5',
  }

  const Icon = type === 'FOOD' ? Utensils : Shirt

  return (
    <span
      className={cn(
        'inline-flex items-center font-medium rounded-full bg-primary/10 text-primary',
        sizeStyles[size]
      )}
    >
      <Icon className={iconSizes[size]} />
      {type === 'FOOD' ? 'Food Vendor' : 'Clothing Vendor'}
    </span>
  )
}
